import { Formik } from 'formik';

import type { DocumentTemplatePage_OneDocumentTemplate } from '../../pages/DocumentTemplate/hooks/useFindOneDocumentTemplateQuery.hook';

import { useInitialValuesFactory } from './hooks/useInitialValuesFactory.hook';
import { DocumentTemplateInfoSchema } from './schemas/document-template-info.schema';
import { DocumentTemplateInfoFormFields } from './DocumentTemplateInfoFormFields';

interface Props {
  readonly initialValues?: DocumentTemplatePage_OneDocumentTemplate;
  readonly onCancel?: () => void;
  readonly onSuccess?: () => void;
  readonly setMustBlockAction?: (mustBlock: boolean) => void;
  readonly showCancelButton?: boolean;
  readonly submitLabel?: string;
  readonly title: string;
  readonly useSubmitFactory: (
    handleSuccess?: () => void,
  ) => (documentTemplate: DocumentTemplatePage_OneDocumentTemplate) => void;
}

export const DocumentTemplateInfoForm = ({
  initialValues: pInitialValues,
  onCancel: handleCancel,
  onSuccess: handleSuccess,
  setMustBlockAction,
  showCancelButton,
  submitLabel = 'Valider',
  title,
  useSubmitFactory,
}: Readonly<Props>) => {
  const { initialValues } = useInitialValuesFactory(pInitialValues);

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={useSubmitFactory(handleSuccess)}
      validationSchema={DocumentTemplateInfoSchema}
    >
      <DocumentTemplateInfoFormFields
        onCancel={handleCancel}
        setMustBlockAction={setMustBlockAction}
        showCancelButton={showCancelButton}
        submitLabel={submitLabel}
        title={title}
      />
    </Formik>
  );
};
